import React, { useState, useEffect } from "react";
import Menu from "./Menu";
import Submenu from "./SubMenu";
import SocialMedia from "./SocialMedia";
import dp from "../../assets/images/dp.png";
import sidebarList from "../../json/menuJson";
import { useNavigate } from "react-router-dom";
import { isEnableSubscription } from "../../constant/const";
import Parse from "parse";

const Sidebar = ({ isOpen, closeSidebar }) => {
  const navigate = useNavigate();
  const [menuList, setmenuList] = useState([]);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [tenantLogo, setTenantLogo] = useState("");
  const [isContactbookEnabled, setIsContactbookEnabled] = useState(true);
  const username = localStorage.getItem("username");
  const image = localStorage.getItem("profileImg") || dp;
  const tenantname = localStorage.getItem("Extand_Class")
    ? JSON.parse(localStorage.getItem("Extand_Class"))?.[0]?.Company
    : "";

  useEffect(() => {
    if (localStorage.getItem("accesstoken")) {
      menuItem();
      fetchTenantLogo();
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("accesstoken")) {
      menuItem();
    }
  }, [isContactbookEnabled]);

  const fetchTenantLogo = async () => {
    try {
      const result = await Parse.Cloud.run("getgeneralsettings");
      if (result?.tenantLogo) {
        setTenantLogo(result.tenantLogo);
      }
      if (result?.enableContactbook !== undefined) {
        setIsContactbookEnabled(result.enableContactbook);
        localStorage.setItem(
          "enableContactbook",
          result.enableContactbook ? "true" : "false"
        );
      }
    } catch (error) {
      console.error("Error fetching tenant logo:", error);
    }
  };

  const filterContactbook = (list) => {
    if (isContactbookEnabled) return list;
    return list.map((item) => {
      if (item.title === "Reports" && Array.isArray(item.children)) {
        return {
          ...item,
          children: item.children.filter(
            (child) => child.title !== "Contactbook"
          )
        };
      }
      return item;
    });
  };

  const menuItem = async () => {
    try {
      if (localStorage.getItem("defaultmenuid")) {
        const Extand_Class = localStorage.getItem("Extand_Class");
        const extClass = Extand_Class && JSON.parse(Extand_Class);
        // console.log("extClass ", extClass);
        let userRole = "contracts_User";
        if (extClass && extClass.length > 0) {
          userRole = extClass[0].UserRole;
        }
        if (
          userRole === "contracts_Admin" ||
          userRole === "contracts_OrgAdmin" ||
          userRole === "contracts_TeamAdmin"
        ) {
          const newSidebarList = sidebarList.map((item) => {
            if (item.title === "Settings") {
              // Make a shallow copy of the item
              const newItem = { ...item };
              if (isEnableSubscription) {
                newItem.children = [
                  ...newItem.children,
                  {
                    icon: "fa-light fa-building-memo",
                    title: "Teams",
                    target: "_self",
                    pageType: "",
                    description: "",
                    objectId: "teams"
                  },
                  {
                    icon: "fa-light fa-users fa-fw",
                    title: "Users",
                    target: "_self",
                    pageType: "",
                    description: "",
                    objectId: "users"
                  },
                  {
                    icon: "fa-light fa-sliders",
                    title: "General Preferences",
                    target: "_self",
                    pageType: "",
                    description: "",
                    objectId: "generalsettings"
                  },
                  {
                    icon: "fa-light fa-clock",
                    title: "Password Expiry",
                    target: "_self",
                    pageType: "",
                    description: "",
                    objectId: "passwordexpirysettings"
                  }
                ];
              } else {
                const arr = newItem.children.slice(0, 1);
                newItem.children = [
                  ...arr,
                  {
                    icon: "fa-light fa-users fa-fw",
                    title: "Users",
                    target: "_self",
                    pageType: "",
                    description: "",
                    objectId: "users"
                  },
                  {
                    icon: "fa-light fa-sliders",
                    title: "General Preferences",
                    target: "_self",
                    pageType: "",
                    description: "",
                    objectId: "generalsettings"
                  },
                  {
                    icon: "fa-light fa-clock",
                    title: "Password Expiry",
                    target: "_self",
                    pageType: "",
                    description: "",
                    objectId: "passwordexpirysettings"
                  }
                ];
              }
              return newItem;
            }
            return item;
          });
          setmenuList(filterContactbook(newSidebarList));
        } else {
          if (!isEnableSubscription) {
            const newSidebarList = sidebarList.map((item) => {
              if (item.title === "Settings") {
                // Make a shallow copy of the item
                const newItem = { ...item };
                const arr = newItem.children.slice(0, 1);
                newItem.children = arr;
                return newItem;
              }
              return item;
            });
            setmenuList(filterContactbook(newSidebarList));
          } else {
            setmenuList(filterContactbook(sidebarList));
          }
        }
      }
    } catch (e) {
      console.error("Problem", e);
    }
  };

  const toggleSubmenu = (title) => {
    setSubmenuOpen({ [title]: !submenuOpen[title] });
  };

  const handleMenuItem = () => {
    closeSidebar();
    setSubmenuOpen({});
  };
  const handleProfile = () => {
    navigate("/profile");
  };
  return (
    <aside
      className={`absolute lg:relative bg-base-100 h-screen overflow-y-auto transition-all z-[500] shadow-lg hide-scrollbar
     ${isOpen ? "w-full md:w-[300px]" : "w-0"}`}
    >
      <div className="flex px-2 py-3 gap-3 items-center shadow-md">
        <div className="w-25 flex items-center justify-center">
          {tenantLogo && (
            <img
              src={tenantLogo}
              alt="Organization Logo"
              className="object-contain"
              title={tenantname}
            />
          )}
        </div>
        <div className="w-75">
          <p
            onClick={handleProfile}
            className="text-[14px] font-bold text-base-content cursor-pointer"
          >
            {username}
          </p>
          <p
            onClick={handleProfile}
            className="cursor-pointer text-[12px] text-base-content mt-1"
          >
            {tenantname}
          </p>
        </div>
      </div>
      <nav
        className="op-menu op-menu-sm"
        aria-label="BrightSign Sidebar Navigation"
      >
        <ul
          className="text-sm"
          role="menubar"
          aria-label="BrightSign Sidebar Navigation"
        >
          {menuList.map((item) =>
            !item.children ? (
              <Menu
                key={item.title}
                item={item}
                isOpen={isOpen}
                closeSidebar={handleMenuItem}
              />
            ) : (
              <Submenu
                key={item.title}
                item={item}
                closeSidebar={closeSidebar}
                toggleSubmenu={toggleSubmenu}
                submenuOpen={submenuOpen}
              />
            )
          )}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
